module.exports = __webpack_public_path__ + "img/-LV4tpTjBJ0HkLgxpmOb.82b181c5.jpg";